export default "__VITE_ASSET__BdgM0bYd__"